export default __webpack_public_path__ + "static/bugswork-light-bab62f6390e4f8d3d8084a3b92c8c1b0.svg";